import { Link } from "react-router-dom";
import { StoreHeader } from "./StoreHeader";
import { StoreFooter } from "./StoreFooter";
import { useEffect } from "react";

export function BlenderPlug() {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, []);

    return (
        <article className="mx-auto max-w-3xl px-4 py-10 text-stone-800">
            {/* Header */}
            <StoreHeader />
            <header className="mb-10">
                <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-emerald-900">
                    Blender Chronicles 🥤
                </h1>
                <p className="mt-2 text-lg text-stone-700">
                    Smoothies, Sukuma Wiki & Hustler Hacks
                </p>
                <p className="mt-1 text-sm italic text-stone-500">
                    Megamart Plug — product guides with Nairobi vibes.
                </p>
            </header>

            {/* Intro */}
            <section className="mb-10 space-y-4 leading-relaxed">
                <p>
                    Sasa imagine unataka smoothie ya mango ama supu ya sukuma wiki — lakini
                    blender yako ni ya analog, inalia kama matatu engine. Bro, upgrade!
                </p>
                <p>
                    Blender ndio plug ya hustler kitchens — kutoka breakfast smoothies hadi
                    secret sauces.
                </p>
                <p>
                    Karibu kwenye <strong>Megamart Plug</strong>. Leo tunapiga story ya
                    features, benefits, na vile blender inakua life hack ya kila nyumba.
                </p>
            </section>

            {/* Features */}
            <section className="mb-12">
                <h2 className="mb-4 text-2xl font-bold text-emerald-900">
                    Key Features
                </h2>
                <ul className="space-y-3 pl-5 list-disc">
                    <li>
                        <strong>Speed Settings:</strong> Low kwa soft fruits, high kwa ice cubes
                        — hakuna excuses.
                    </li>
                    <li>
                        <strong>Pulse Mode:</strong> Kama DJ akipiga scratch — full control ya
                        texture.
                    </li>
                    <li>
                        <strong>Jar Capacity:</strong> Ndogo kwa bachelors, kubwa kwa family ya
                        Nairobi West.
                    </li>
                    <li>
                        <strong>Blade Design:</strong> Stainless steel — inakata kila kitu
                        isipokuwa stress zako.
                    </li>
                </ul>
            </section>

            {/* Benefits */}
            <section className="mb-12">
                <h2 className="mb-4 text-2xl font-bold text-emerald-900">
                    Benefits — Why It’s the Plug
                </h2>
                <ul className="space-y-3 pl-5 list-disc">
                    <li>
                        <strong>Healthy Living:</strong> Smoothies zinakufanya uonekane
                        disciplined, hata kama chips ni lifestyle.
                    </li>
                    <li>
                        <strong>Time Saver:</strong> Supu ya sukuma wiki inakuwa ready in
                        minutes.
                    </li>
                    <li>
                        <strong>Versatility:</strong> Sauces, juices, baby food — blender ni
                        multitasker.
                    </li>
                    <li>
                        <strong>Flex Factor:</strong> Guests wakiona blender yako premium,
                        wanajua uko serious.
                    </li>
                </ul>
            </section>

            {/* Chronicles */}
            <section className="mb-12 space-y-4">
                <h2 className="text-2xl font-bold text-emerald-900">
                    Chronicles from the Kitchen
                </h2>
                <p>
                    Kuna siku nilijaribu kusaga ice na blender ya analog — ilikuwa kama
                    generator ya construction site. Lesson learnt: blades matter.
                </p>
                <p>
                    Bachelor tip: banana + peanut butter smoothie = instant gym flex.
                    Blender ni wingman wa fitness.
                </p>
            </section>

            {/* Budget Guide */}
            <section className="mb-14">
                <h2 className="mb-6 text-2xl font-bold text-emerald-900">
                    Budget Guide 💸
                </h2>

                <div className="grid gap-6 md:grid-cols-3">
                    {[
                        {
                            title: "Entry-Level",
                            desc: "Basic speeds, small jar — kazi inafanyika.",
                            link: "/products?search=budget%20blender",
                        },
                        {
                            title: "Mid-Range",
                            desc: "Multiple speeds, bigger jar — value + convenience.",
                            link: "/products?search=mid%20range%20blender",
                        },
                        {
                            title: "Premium",
                            desc: "Ice crushing, smart controls — mabazu edition.",
                            link: "/products?search=premium%20blender",
                        },
                    ].map((item) => (
                        <div
                            key={item.title}
                            className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm"
                        >
                            <h3 className="font-semibold text-stone-900">{item.title}</h3>
                            <p className="mt-1 text-sm text-stone-600">{item.desc}</p>
                            <Link
                                to={item.link}
                                className="mt-3 inline-block text-sm font-semibold text-red-600 hover:underline"
                            >
                                Browse options →
                            </Link>
                        </div>
                    ))}
                </div>
            </section>

            {/* CTA + Video */}
            <section className="mb-16">
                <div className="rounded-2xl border border-stone-200 bg-stone-50 p-6 space-y-6">
                    <div>
                        <h3 className="text-xl font-bold text-emerald-900">
                            Ready to Blend Like a Boss?
                        </h3>
                        <p className="mt-2">
                            Kama unataka smoothies, sauces, na supu bila drama — blender ndio
                            plug. <strong>Megamart</strong> iko na options zote.
                        </p>
                    </div>

                    <Link
                        to="/products?search=blender"
                        className="inline-flex items-center justify-center rounded-md
                       bg-red-600 px-6 py-2 text-white font-semibold
                       hover:bg-red-700 transition"
                    >
                        Shop Blenders on Megamart.co.ke
                    </Link>

                    {/* Video */}
                    <div className="rounded-xl overflow-hidden border border-stone-200 bg-black">
                        <div className="relative aspect-video">
                            <iframe
                                src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1566728197869729%2F&show_text=false"
                                className="absolute inset-0 h-full w-full"
                                style={{ border: "none" }}
                                scrolling="no"
                                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                allowFullScreen
                            />
                        </div>
                        <p className="bg-white px-4 py-2 text-sm text-stone-600 text-center">
                            Watch how a proper blender handles real kitchen work
                        </p>

                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="border-t pt-6 text-sm text-stone-600">
                Megamart Plug — product guides, care tips, and Nairobi kitchen hacks.{" "}
                <Link to="/plug" className="font-semibold text-red-600 hover:underline">
                    Discover more guides
                </Link>
                .
            </footer>
            <StoreFooter />
        </article>
    );
}
